import { AuthGuard } from 'src/app/core/guards/auth-guard/auth.guard';
import { Routes } from '@angular/router';
import { NotFoundComponent } from 'src/app/pages/not-found/not-found.component';
import { giftRegistryFlowGuard } from 'src/app/pages/payments/guards/gift-registry-flow/gift-registry-flow.guard';
import { GiftRegistrySegments } from 'src/app/shared/constants';

export const GIFT_REGISTRY_ROUTES: Routes = [
  {
    path: GiftRegistrySegments.Reference,
    loadComponent: () =>
      import('../gift-registry-reference-step/gift-registry-reference-step.component').then(
        (c) => c.GiftRegistryReferenceStepComponent,
      ),
  },
  {
    path: GiftRegistrySegments.AccessCode,
    canActivate: [giftRegistryFlowGuard],
    loadComponent: () =>
      import('../gift-registry-access-code-step/gift-registry-access-code-step.component').then(
        (c) => c.GiftRegistryAccessCodeStepComponent,
      ),
  },
  {
    path: GiftRegistrySegments.Surname,
    canActivate: [giftRegistryFlowGuard],
    loadComponent: () =>
      import('../gift-registry-surname-step/gift-registry-surname-step.component').then(
        (c) => c.GiftRegistrySurnameStepComponent,
      ),
  },
  {
    path: GiftRegistrySegments.MagicLink,
    loadComponent: () =>
      import('../gift-registry-magic-link/gift-registry-magic-link.component').then(
        (c) => c.GiftRegistryMagicLinkComponent,
      ),
  },
  {
    path: '**',
    canActivate: [AuthGuard],
    component: NotFoundComponent,
  },
];
